export default {
  'ceil': (v: number) => Math.ceil(v),
  'divided_by': (v: number, arg: number) => v / arg,
  'floor': (v: number) => Math.floor(v),
  'minus': (v: number, arg: number) => Number(v || 0) - Number(arg),
  'modulo': (v: number, arg: number) => v % arg,
  'round': (v: number, arg: number = 0) => {
    const amp = Math.pow(10, arg)
    return Math.round(v * amp) / amp
  },
  'plus': (v: number, arg: number) => Number(v || 0) + Number(arg),
  'times': (v: number, arg: number) => v * arg
}
